import { get } from 'svelte/store';
import { textStore, grammarActions } from '$lib/stores/grammar';
import { SUBSCRIPTION_LIMITS } from '$lib/constants/subscription';

/**
 * Service for handling upgrade prompt logic
 */
export class UpgradePromptService {
  /**
   * Get modal title based on reason
   */
  static getModalTitle(reason: string, details?: string): string {
    switch (reason) {
      case 'limit_reached':
        return details?.includes('분당') ? '분당 사용 한도 초과' : '오늘의 사용 한도 도달';
      case 'ai_feature_limit':
        return 'AI 기능 사용 한도 도달';
      case 'trial_expiring':
        return '체험 기간 곧 종료';
      case 'trial_expired':
        return '체험 기간이 종료되었습니다';
      case 'feature_locked':
        if (details === 'AI 분석은 프리미엄 기능입니다') return 'AI 분석 잠금 해제하기';
        if (details === 'AI 분석 - 프리미엄 모델 선택') return '프리미엄 AI 모델';
        return '프리미엄 기능';
      case 'text_too_long':
        return '글자수 제한';
      default:
        return '업그레이드 필요';
    }
  }

  /**
   * Handle modal close action
   */
  static handleModalClose(reason: string): void {
    // If closing text length limit prompt with "나중에", trim text to FREE tier limit
    if (reason === 'text_too_long') {
      const currentTextState = get(textStore);
      const currentText = currentTextState.current || currentTextState.original;
      const maxLength = SUBSCRIPTION_LIMITS.FREE.maxTextLength;
      if (currentText && currentText.length > maxLength) {
        const trimmedText = currentText.substring(0, maxLength);
        grammarActions.setText(trimmedText);
        // Clear any errors since we're changing the text
        grammarActions.setErrors([]);
      }
    }
  }

  /**
   * Check if modal should have AI-specific styling
   */
  static isAIModal(reason: string, details?: string): boolean {
    return reason === 'feature_locked' && 
           (details === 'AI 분석은 프리미엄 기능입니다' || 
            details === 'AI 분석 - 프리미엄 모델 선택');
  }

  /**
   * Get secondary button text
   */
  static getSecondaryButtonText(reason: string): string {
    return reason === 'trial_expired' ? '무료로 계속 사용하기' : '나중에';
  }
}